import { forwardRef, useEffect, useState } from "react";
import MapView from "@arcgis/core/views/MapView";
import Map from "@arcgis/core/Map.js";
import * as promiseUtils from "@arcgis/core/core/promiseUtils.js";
import Graphic from "@arcgis/core/Graphic";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";


const OverviewMapComponent = forwardRef(({ view, basemap, extent }, ref) => {

    // Create the MapView for overview map
    const mapView1 = new MapView({
        map: new Map({
            basemap: basemap
        }),
        constraints: {
            rotationEnabled: false
        }
    });

    const extentGraphic = new Graphic({
        geometry: null,
        symbol: {
            type: "simple-fill",
            color: [0, 0, 0, 0.5],
            outline: null
        }
    });

    const [mapView, setmapView] = useState(mapView1)

    /**
     * Función que modifica el zoom y la extensión del mapa auxiliar sincronizado con el mapa principal
     */
    const extentDebouncer = promiseUtils.debounce(async () => {
        if (view.stationary) {
            await mapView.goTo({
                center: view.center,
                scale:
                    view.scale *
                    2 *
                    Math.max(
                        view.width / mapView.width,
                        view.height / mapView.height
                    )
            });
        }
    });

    /**
     * Función que añade el cuadro de sombra al mapa auxiliar
     */
    const setup = () => {
        mapView.graphics.add(extentGraphic);
    }

    useEffect(() => {
        if (mapView) {
            mapView.container = ref.current

            // Remove the default widgets
            mapView.ui.components = [];
            setmapView(mapView)
            mapView.when(() => {
                view.when(() => {
                    setup();
                });
            });

        }
    }, [])

    useEffect(() => {

        /**
         * Función que modifica la extensión del cuadro que sombrea
         */
        reactiveUtils.watch(
            () => view.extent,
            (extent) => {
                // Sync the overview map location
                extentDebouncer().then(() => {
                    extentGraphic.geometry = extent;
                });
            },
            {
                initial: true
            }
        );
    }, [extent])


    return (
        <>
            <div ref={ref} className="overviewDiv">
                <div className="extentDiv"></div>
            </div>
        </>

    )
})

export default OverviewMapComponent;